import React, { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone } from "lucide-react";
import { cn } from "@/lib/utils";

export const Navigation = ({ onContactClick }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navItems = [
    { label: "Services", href: "#services" },
    { label: "Portfolio", href: "#portfolio" },
    { label: "Process", href: "#process" },
    { label: "Testimonials", href: "#testimonials" },
    { label: "FAQ", href: "#faq" },
  ];

  return (
    <nav
      data-testid="primary-nav"
      className={cn(
        "fixed top-0 left-0 right-0 z-50 transition-all duration-300",
        isScrolled
          ? "bg-background/70 backdrop-blur-lg border-b border-[hsl(var(--border))]"
          : "bg-transparent"
      )}
    >
      <div className="container">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <a
            href="/"
            data-testid="site-logo-link"
            className={cn(
              "text-2xl font-display font-semibold hover:text-[hsl(var(--brand-gold))] transition-colors",
              isScrolled ? "text-foreground" : "text-white"
            )}
          >
            Homz Interio
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={cn(
                  "text-sm tracking-[0.1em] uppercase hover:text-[hsl(var(--brand-gold))] transition-colors",
                  isScrolled ? "text-foreground/80" : "text-white/90"
                )}
              >
                {item.label}
              </a>
            ))}
            <Button
              variant="gold"
              size="lg"
              onClick={onContactClick}
              data-testid="nav-schedule-button"
            >
              <Phone className="w-4 h-4" />
              Schedule Consultation
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={cn(
              "md:hidden p-2",
              isScrolled ? "text-foreground" : "text-white"
            )}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            data-testid="mobile-menu-toggle"
          >
            {isMobileMenuOpen ? <X /> : <Menu />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden pb-4 border-t border-[hsl(var(--border))] mt-2">
            <div className="flex flex-col gap-4 pt-4">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-sm tracking-[0.1em] uppercase text-foreground/80 hover:text-[hsl(var(--brand-gold))] transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <Button
                variant="gold"
                size="lg"
                onClick={() => {
                  onContactClick();
                  setIsMobileMenuOpen(false);
                }}
                className="w-full"
              >
                <Phone className="w-4 h-4" />
                Schedule Consultation
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
